<template>
  <div v-bind="$attrs" class="baseInfo">
    <div class="form-block">
      <status-info :certification="certification" />
      <h3 class="head">基础信息</h3>
      <div class="form-item">
        <span class="form-item-label">公司名称:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.companyNameZh
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">公司简称:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.companyAbbreviation
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">公司曾用名:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.usedCompanyName
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">公司英文名:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.companyNameEn
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">所在地:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.location
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">详细地址:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.address
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">注册时间:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.registerTime
            ? formatDate(certification.registerTime)
            : '--'
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">企业网站:</span>
        <span class="form-item-inner form-item-inner--text">{{
          certification.website
        }}</span>
      </div>
      <div class="form-item">
        <span class="form-item-label">受邀钢厂:</span>
        <span class="form-item-inner form-item-inner--text">
          {{certification.invitedSteel | formatInviteSteelText}}
        </span>
      </div>
      <div class="form-item">
        <span class="form-item-label">认证目的:</span>
        <span class="form-item-inner form-item-inner--text">
          {{ certification.authPurpose }}
        </span>
      </div>
    </div>
    <div class="form-block">
      <h3 class="head">联系方式</h3>
      <div class="form-item">
        <span class="form-item-label">联系人:</span>
        <div class="form-item-inner form-item-inner--text">
          <span v-if="!canUpdateCompanyInfo">{{ certification.contactPerson }}</span>
          <template v-else>
            <div class="edit__field">
              <input ref="contactPerson" type="text" maxlength="10" v-model="contactPerson" :disabled="!editContactPerson" name="contactPerson" />
              <p class="edit__field--error" v-if="contactPersonError">{{ contactPersonError }}</p>
            </div>
            <a href="javascript:;" class="edit__btn" v-if="!editContactPerson" @click="handleChangeFieldEditMode('contactPerson', true)">修改</a>
            <template v-if="editContactPerson">
              <a href="javascript:;" class="edit__btn" @click="handleSaveFieldValue('contactPerson')">保存</a>
              <a href="javascript:;" class="edit__btn" @click="handleChangeFieldEditMode('contactPerson', false)">取消</a>
            </template>
          </template>
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-label">联系电话:</span>
        <div class="form-item-inner form-item-inner--text">
          <span v-if="!canUpdateCompanyInfo">{{ certification.contactPhone }}</span>
          <template v-else>
            <div class="edit__field">
              <input ref="contactPhone" maxlength="11" type="text" v-model="contactPhone" :disabled="!editContactPhone" name="contactPhone" />
              <p class="edit__field--error" v-if="contactPhoneError">{{ contactPhoneError }}</p>
            </div>
            <a href="javascript:;" class="edit__btn" v-if="!editContactPhone" @click="handleChangeFieldEditMode('contactPhone', true)">修改</a>
            <template v-if="editContactPhone">
              <a href="javascript:;" class="edit__btn" @click="handleSaveFieldValue('contactPhone')">保存</a>
              <a href="javascript:;" class="edit__btn" @click="handleChangeFieldEditMode('contactPhone', false)">取消</a>
            </template>
          </template>
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-label">企业电话:</span>
        <div class="form-item-inner form-item-inner--text">
          {{ certification.enterprisePhone }}
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-label">企业传真:</span>
        <div class="form-item-inner form-item-inner--text">
          {{ certification.corporateFax }}
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-label">邮编:</span>
        <div class="form-item-inner form-item-inner--text">
          {{ certification.zipCode }}
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-label">QQ:</span>
        <div class="form-item-inner form-item-inner--text">
          {{ certification.qq }}
        </div>
      </div>
    </div>
    <div class="form-block">
      <h3 class="head">
        证件附件
        <span class="tip">资质信息提交之后不可修改，请确认信息无误，如有疑问，请联系钢信400-088-6868</span>
      </h3>
      <div class="form-item">
        <div class="img">
          <img
            v-if="certification.bizLicense"
            :src="certification.bizLicense"
          />
          <p class="file-label">营业执照</p>
          <p v-if="!certification.bizLicense" class="placeholder">暂未上传</p>
        </div>
        <div class="img">
          <img
            v-if="certification.authorization"
            :src="certification.authorization"
          />
          <p class="file-label">委托书</p>
          <p v-if="!certification.authorization" class="placeholder">
            暂未上传
          </p>
        </div>
        <div class="img">
          <img v-if="certification.orgCode" :src="certification.orgCode" />
          <p class="file-label">组织机构代码</p>
          <p v-if="!certification.orgCode" class="placeholder">暂未上传</p>
        </div>
        <div class="img">
          <img
            v-if="certification.taxRegCert"
            :src="certification.taxRegCert"
          />
          <p class="file-label">税务登记证</p>
          <p v-if="!certification.taxRegCert" class="placeholder">暂未上传</p>
        </div>
        <div class="img" v-if="certification.accountLicense">
          <img
            v-if="certification.accountLicense"
            :src="certification.accountLicense"
          />
          <p class="file-label">开户许可证</p>
          <p v-if="!certification.accountLicense" class="placeholder">
            暂未上传
          </p>
        </div>
      </div>
    </div>
    <div class="form-block" v-if="hasSupplier">
      <category-select
        :defaultCheckedKeys="supplierKeys"
        :tree-data="treeData"
        :disabled="!canUpdateSupplier"
        @onChange="handleSupplierChange"
      >
        <h3 class="head">供应品类</h3>
        <div class="form-item form-item--space">
          <span class="form-item-label">
            厂家类型:
          </span>
          <div class="form-item-inner form-item-inner--text">
            {{certification.manufactorTypeName}}
          </div>
        </div>
      </category-select>
    </div>
    <div class="form-block" v-if="hasPurchaser">
      <category-select
        :defaultCheckedKeys="purchaserKeys"
        moduleType="采购"
        :tree-data="treeData"
        :disabled="!canUpdatePurchaser"
        @onChange="handlePurchaserChange"
      >
        <h3 class="head">采购品类</h3>
      </category-select>
    </div>
    <slot />
    <div class="form-block" v-if="hasSupplier || hasPurchaser">
      <h3 class="head">外贸信息</h3>
      <div class="form-item">
        <span class="form-item-label">外贸资质:</span>
        <div class="form-item-inner form-item-inner--text">
          {{ certification.foreignTradeCert ? '具备' : '不具备' }}
        </div>
      </div>
      <template v-if="certification.foreignTradeCert">
        <div class="form-item">
          <span class="form-item-label">对外贸易经营者备案登记表附件:</span>
          <div class="form-item-inner form-item-inner--imgs">
            <div class="form-item-inner--imgs-item">
              <img :src="certification.foreignTradeRegistry" />
            </div>
          </div>
        </div>
        <div class="form-item">
          <span class="form-item-label">进出口企业代码号:</span>
          <div class="form-item-inner form-item-inner--text">
            {{ certification.foreignTradeCode }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import { mixins } from '@/utils';
  import CategorySelect from '@/modules/CategorySelect';
  import Input from '@/components/Input';
  import StatusInfo from '../status';
  import { certificationStatusCode, enterpriseCertRules } from '@/config';
  import api from '@/api';

  export default {
    name: 'cert-base-info',
    data() {
      return {
        treeData: [],

        editContactPerson: false,
        contactPerson: '',
        contactPersonError: '',

        editContactPhone: false,
        contactPhone: '',
        contactPhoneError: '',

        supplierKeys: [],
        purchaserKeys: [],
      };
    },
    methods: {
      update(categoryInfo) {
        this.treeData = categoryInfo.treeData;
        this.supplierKeys = categoryInfo.supplierKeys || [];
        this.purchaserKeys = categoryInfo.purchaserKeys || [];
      },
      handleSupplierChange(data) {
        this.$emit('supplierChange', data);
      },
      handlePurchaserChange(data) {
        this.$emit('purchaserChange', data);
      },
      updateContactInfo(certInfo) {
        this.contactPerson = certInfo.contactPerson;
        this.contactPhone = certInfo.contactPhone;
      },
      handleChangeFieldEditMode(field, mode) {
        if (field === 'contactPhone') {
          this.editContactPhone = mode;
          this.contactPhoneError = '';
          this.$nextTick(() => {
            this.contactPhone = this.certification.contactPhone;
            this.$refs.contactPhone.focus();
          });
        } else {
          this.editContactPerson = mode;
          this.contactPersonError = '';
          this.$nextTick(() => {
            this.contactPerson = this.certification.contactPerson;
            this.$refs.contactPerson.focus();
          });
        }
      },
      handleSaveFieldValue(field) {
        if (!this.validate(field)) {
          return ;
        }
        this.submitData(field);
      },
      submitData(field) {
        const fieldInfo = {
          type: field === 'contactPerson' ? '联系人' : '联系电话',
          value: this[field],
        };

        this.$confirm(`确定修改${fieldInfo.type}修改为【${fieldInfo.value}】吗？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let data = {
            [field]: fieldInfo.value,
          };
          if (field === 'contactPerson') {
            this.editContactPerson = false;
          } else {
            this.editContactPhone = false;
          }
          api.updateCertContactInfo(data)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('保存成功');
                this.$emit('updateCertInfo');
              }
            });
        });
      },
      validate(field) {
        if (field === 'contactPhone') {
          const { isValid, error } = this.validateField(this.contactPhone, enterpriseCertRules.contactPhone);
          this.contactPhoneError = error;
          return isValid;
        }
        const { isValid, error } = this.validateField(this.contactPerson, enterpriseCertRules.contactPerson);
        this.contactPersonError = error;
        return isValid;
      },
    },
    computed: {
      hasCenpur() {
        return this.hasSupplier || this.hasPurchaser;
      },
      canUpdateCompanyInfo() {
        return this.certification.auditStatus === certificationStatusCode.opened;
      },
    },
    watch: {
      categoryInfo: {
        handler(value) {
          this.update(value);
        },
        immediate: true,
      },
      certification: {
        handler(certInfo) {
          this.updateContactInfo(certInfo);
        },
        immediate: true
      }
    },
    mixins: [mixins],
    props: {
      certification: {
        default: () => {},
        type: Object,
      },
      hasSupplier: {
        type: Boolean,
        default: false,
      },
      hasPurchaser: {
        type: Boolean,
        default: false,
      },
      categoryInfo: {
        treeData: [],
        supplierKeys: [],
        purchaserKeys: [],
      },
      canUpdateSupplier: {
        type: Boolean,
        default: true,
      },
      canUpdatePurchaser: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      CategorySelect,
      StatusInfo,
      Input,
    },
  };
</script>
<style lang="scss" scoped>
  @import '../style';
</style>